import { BONUS } from '../../constants/Currency';
import { getCurrencyLabel } from '../../CurrencyConfig';
import isBoolean from 'lodash/isBoolean';

const getCurrencySymbol = (t: any, isCash?: boolean | null) => {
  if (!isBoolean(isCash)) {
    return '';
  }
  if (!isCash) {
    return BONUS;
  }
  return getCurrencyLabel(t);
};
export default getCurrencySymbol;
